import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-reminder-message',
  templateUrl: './reminder-message.component.html',
  styleUrls: ['./reminder-message.component.scss'],
})
export class ReminderMessageComponent implements OnInit {
  @Input() message: string;
  @Input() type: 'reminder' | 'warning' | 'error' | 'confirm';
  @Input() validateAccount: boolean;
  @Input() loadingIcon: boolean;
  @Input() hiddenIcon: boolean;
  src: string;

  constructor(private router: Router) {}

  ngOnInit(): void {
    switch (this.type) {
      case 'error':
        this.src = '/assets/icons/error.svg';
        break;
      case 'warning':
        this.src = '/assets/icons/alert-warning-message.svg';
        break;
      case 'confirm':
        this.src = '/assets/icons/confirm-time.svg';
        break;
      default:
        // type === reminder || otra cosa
        this.src = '/assets/icons/alert-reminder-message.svg';
        break;
    }
  }

  routeToOnBoarding() {
    this.router.navigate(['/auth', 'signup']);
  }
}
